<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Rolling</h3>
                    
                    <div class="mb-3">
                        <label for="game_id" class="form-label">API Provider <em>*</em></label>
                        <select class="form-control" id="game_id" name="provider" #game_id="ngModel" [(ngModel)]="data.game_id" required [disabled]="rolling_uuid">
                            <option [value]="provider.id" *ngFor="let provider of providers">{{provider.name}}</option>
                        </select>
                    </div>


                    <div class="row" *ngIf="categories.length > 0">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="type" class="form-label">Provider Category <em>*</em></label>
                                <select class="form-control" id="type" name="type" [(ngModel)]="data.type" [disabled]="rolling_uuid">
                                    <option [value]="t.id" *ngFor="let t of categories">{{t.title}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="self" class="form-label">Self (%)</label>
                        <input type="text" class="form-control" id="self" name="self" #self="ngModel" [(ngModel)]="data.self" autocomplete="off">
                    </div>

                    <div class="mb-3">
                        <label for="level_1" class="form-label">Level 1 (%)</label>
                        <input type="text" class="form-control" id="level_1" name="level_1" #level_1="ngModel" [(ngModel)]="data.level_1" autocomplete="off">
                    </div>

                    <div class="mb-3">
                        <label for="level_2" class="form-label">Level 2 (%)</label>
                        <input type="text" class="form-control" id="level_2" name="level_2" #level_2="ngModel" [(ngModel)]="data.level_2" autocomplete="off">
                    </div>

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>
